
export const sex = {
    1: '男',
    2: '女'
}

export const whether = {
    1: '是',
    0: '否'
}

export const degreeStatus = {
    0: '待提交',
    1: '待审核',
    2: '审核通过',
    3: '审核不通过',
    4: '打回修改',
    5: '通过现场验证',
}

export const degreexxxs = {
    11: '自考全日制专科',
    12: '自考全日制专升本',
    14: '自考非全日制专科',
    15: '自考非全日制专升本',
}
export const degreeLanguage = {
    'CH': '中文',
    'EN': '英文'
}
export const degreeEflType = {
    '1': '成人学士学位外语',
    '2': 'cet-4',
    '3': 'cet-6',
    '4': 'pets-4',
    '5': '成人学士学位第二外语',
    '6': '专业英语四级',
    '7': '专业日语一级',
    '8': '英语（专升本）',
}


export const o_fee_type = {
  'MIANSHOU': '面授',
  'ZXKT': '在线课堂',
  'KJXX': '课件学习',
  'SJJN': '实践技能',
  'SJJN2': '实践技能二',
  'BYLW': '毕业论文',
  'BYLW2': '毕业论文二',
  'TK': '统考报名',
  'MIANSHOU_ZB': '面授直播课',
  'ZXKT_ZB': '在线课堂直播课',
  'COURSELIVE': '公开课',
}

export const o_status = {
  'UNPAID': '未缴费',
  'PAID': '已缴费',
}

export const o_pay_way = {
  'WXPAY': '微信',
  'ALIPAY': '支付宝',
  'JHPAY': '聚合',
}
export const quesMaps = {
  1: '单选题',
  2: '多选题',
  3: '判断题',
  4: '填空题',
  5: '问答题',
  6: '名词解释题',
  7: '论述题',
  8: '简答题',
  9: '套题'
}

export const check_status = {
  '0': '未审核',
  '1': '通过',
  '-1': '不通过',
}
export const myThesisStatus = {
  '0': '上传初稿',
  '1': '待审核',
  '2': '审核通过',
  '3': '审核不通过',
  '4': '打回修改',
}

export const defenseStatus = {
  '0': '待答辩',
  '1': '答辩通过',
  '2': '答辩不通过',
  '3': '答辩完成',
}

export const examTimes = {
  A: "星期六（9:00-11:30）",
  B: "星期六（14:00-17:30）",
  C: "星期天（9:00-11:30）",
  D: "星期天（14:00-17:30）",
  X: "星期五（9:00-11:30）",
  Y: "星期五（14:00-17:30）",
  H: "星期一（9:00-11:30）",
  I: "星期一（14:00-17:30）",
  J: "星期二（9:00-11:30）",
  K: "星期二（14:00-17:30）"
}
